import React from "react";
import ReactDOM from "react-dom/client";
import { MenuProvider } from "./menuContext";
import "./index.scss";
import "./App.scss";
import App from "./App";
import { CodeSampleLightDarkModeProvider } from "./components/CodeSamplesContainer/CodeSampleLightDarkModeContext";
import TagManager, { TagManagerArgs } from "react-gtm-module";

// Following lines are to configure and initialize Google Tag Manager
const TAG_MANAGER_ARGS: TagManagerArgs = {
    gtmId: "G-46TE4XWWRF"
};

TagManager.initialize(TAG_MANAGER_ARGS);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <React.StrictMode>
        <MenuProvider>
            <CodeSampleLightDarkModeProvider>
                <App />
            </CodeSampleLightDarkModeProvider>
        </MenuProvider>
    </React.StrictMode>
);
